// extracted by mini-css-extract-plugin
export default {"ellipsis":"ellipsis_Ellipsis-module_1KKSK","tooltip":"tooltip_Ellipsis-module_3e7Pj","projectIcon":"projectIcon_Ellipsis-module_2XYgi"};